module.exports = __webpack_public_path__ + "static/media/acceuil_3.9bbd60f2.jpg";